import { useState } from "react";

import { createNotification } from "../../services/adminApi";

import NotificationPreview from "./NotificationPreview";

const NotificationForm = () => {

    const [form, setForm] = useState({

        title: "",

        message: "",

        audience: "all",

        type: "general",

        deepLink: "",

        image: "",

        schedule: false,

        scheduledAt: ""

    });

    const [loading, setLoading] = useState(false);

    const handleChange = (e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value,
        }));

    };

    const handleSubmit = async (e) => {

        e.preventDefault();

        try {

            setLoading(true);

            await createNotification(form);

            alert("Notification Created Successfully");

            setForm({

                title: "",

                message: "",

                audience: "all",

                type: "general",

                deepLink: "",

                image: "",

                schedule: false,

                scheduledAt: ""

            });

        } catch (err) {

            console.error(err);

            alert("Failed to create notification");

        } finally {

            setLoading(false);

        }

    };

    return (

        <div className="notification-form-container">

            <form
                className="notification-form"
                onSubmit={handleSubmit}
            >

                <label>Title</label>

                <input
                    name="title"
                    value={form.title}
                    onChange={handleChange}
                    required
                />

                <label>Message</label>

                <textarea
                    rows={5}
                    name="message"
                    value={form.message}
                    onChange={handleChange}
                    required
                />

                <label>Audience</label>

                <select
                    name="audience"
                    value={form.audience}
                    onChange={handleChange}
                >
                    <option value="all">All</option>
                    <option value="customers">Customers</option>
                    <option value="providers">Providers</option>
                    <option value="deliveryPartners">
                        Delivery Partners
                    </option>
                </select>

                <label>Notification Type</label>

                <select
                    name="type"
                    value={form.type}
                    onChange={handleChange}
                >
                    <option value="general">General</option>
                    <option value="announcement">
                        Announcement
                    </option>
                    <option value="offer">
                        Offer
                    </option>
                    <option value="order">
                        Order
                    </option>
                    <option value="payment">
                        Payment
                    </option>
                    <option value="account">
                        Account
                    </option>
                </select>

                <label>Deep Link</label>

                <input
                    name="deepLink"
                    value={form.deepLink}
                    onChange={handleChange}
                />

                <button
                    className="submit-btn"
                    disabled={loading}
                >
                    {loading
                        ? "Creating..."
                        : "Create Notification"}
                </button>

            </form>

            <NotificationPreview form={form} />

        </div>

    );

};

export default NotificationForm;